export {
  barWidth,
  hours,
  index,
  percent,
  signedHours,
  useHourFormat,
  type HourFormat,
} from '../finance/finance-format';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ C65 · the hours dashboard's number rules.                                 │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **THE SAME RULES AS THE MONEY TAB, BECAUSE THEY SIT SIDE BY SIDE.** A reader moves between
 * the two tabs comparing figures, and `−1:30` on one against `-1.5` on the other is the same fact
 * twice in two spellings. `H:MM`, the percentage, the index and the bar's clamp are all already
 * decided in `finance-format.ts` and are re-exported rather than re-derived.
 *
 * ⚠️ **The MINUS is U+2212, not a hyphen** — a hyphen in a column of `tabular-nums` sits at a
 * different height and width from the digits beside it.
 */

/** `+3 munkanap` / `−2 nap` — a signed COUNT with its unit. ⚠️ Zero is `0`, not `+0`. */
export function signedCount(value: number | null, unit: string): string {
  if (value === null) return '–';
  const sign = value > 0 ? '+' : value < 0 ? '−' : '';
  return `${sign}${String(Math.abs(value))} ${unit}`;
}
